import { render, staticRenderFns } from "./scada-page.vue?vue&type=template&id=2e5595ca&lang=pug&"
import script from "./scada-page.vue?vue&type=script&lang=js&"
export * from "./scada-page.vue?vue&type=script&lang=js&"
import style0 from "./scada-page.vue?vue&type=style&index=0&id=2e5595ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports